// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"669e7042","453":"474a9da8","732":"ed66297e","977":"95ba8644"}[chunkId] + ".chunk.js";
};